import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PIcon } from '@porsche-design-system/components-react';

const MessageWrapper = styled('div', {
  base: {
    marginTop: 'xs',
  },

  variants: {
    state: {
      info: {
        color: 'text.primary',
      },
      error: {
        color: 'text.error',
      },
    },
  },

  defaultVariants: {
    state: 'error',
  },
});

const Icon = styled(
  PIcon,
  {
    base: {
      marginRight: 'xs',
    },
  },
  { forwardProps: ['color'] },
);

export const Message = ({
  value,
  state = 'error',
}: {
  value?: string | null;
  state?: 'error' | 'info';
}) => {
  if (!value) return null;

  return (
    <MessageWrapper state={state}>
      <Icon
        name="information"
        {...(state === 'error' && { color: 'text.error' })}
      />
      {value}
    </MessageWrapper>
  );
};
